<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<div class="media-header-wp" *ngIf="showControls">
  <div class="media-btn-wp">
    <button (click)="cancel()" class="media-cancel-btn">
      <rx-icon size="36" [name]="'cross-white'"></rx-icon>
    </button>
  </div>
  <div class="title-container" *ngIf="currentImage?.date">
    <div class="date-time-wp">
      <div *ngIf="!!data.dateReplacers" class="date">
        {{ currentImage.date | dateFormat: 'MMM DD, YYYY' | stringReplacer: data.dateReplacers }}
      </div>
      <div *ngIf="!data.dateReplacers" class="date">{{ currentImage.date | dateFormat: 'MMM DD, YYYY' }}</div>

      <div class="time">
        {{ currentImage.date | dateFormat: (!!data.timeFormat ? data.timeFormat : ' h:mm A') }}
      </div>
    </div>
  </div>
  <div class="media-btn-wp"></div>
</div>

<div class="image-wp" (swipeleft)="showPreviousItem()" (swiperight)="showNextItem()">
  <pinch-zoom class="img-wrap" [limit-zoom]="4" *ngIf="!currentImage?.isVideo">
    <img [src]="currentImage.imageUrl" alt="" (click)="toggleShowControls()" />
  </pinch-zoom>
  <div *ngIf="currentImage?.isVideo" class="video-wp">
    <video controls #videoPlayer (playing)="videoActions($event)" (pause)="videoActions($event)">
      <source [src]="currentImage.imageUrl" />
      Browser not supported
    </video>
  </div>
  <div class="arrows prev" (click)="showPreviousItem()" *ngIf="images?.length > 1 && showControls">
    <rx-icon name="arr-in-circle" size="54"></rx-icon>
  </div>
  <div class="arrows next" (click)="showNextItem()" *ngIf="images?.length > 1 && showControls">
    <rx-icon name="arr-in-circle" size="54"></rx-icon>
  </div>
</div>

<div
  class="note-container"
  *ngIf="currentImage?.notes?.length"
  [ngClass]="{ 'expand-notes': expandNotes }"
  (click)="toggleExpandNotes()"
>
  <div class="note-item" *ngFor="let note of currentImage.notes" [ngClass]="{ 'is-my-note': note.isMyNote }">
    <div class="note-title">
      {{ note.publication_date | dateFormat: 'MMMM DD, YYYY' }}
      <span>, {{ note.author.name }}</span>
    </div>
    <div class="note-text">{{ note.note }}</div>
  </div>
</div>
